import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  GridItem,
  Select,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Text,
  Heading,
  VStack,
  Button,
  HStack,
} from "@chakra-ui/react";
// import { Function } from "@chakra-ui/icons";
import { MaterialSymbol } from "react-material-symbols";
import { HeatTable } from "./HeatTable";
import { ENDPOINT } from "../api";

// import ScatterPlot from "./ScatterPlot";

// Example values (n_rows x n_cols)
const vals = [
  [0.613, 0.619, 0.606, 0.606],
  [0.001, 0.522, 0.559, 0.562],
  [0.579, 0.578, 0.582, 0.532],
];

const rows = ["OQ1", "OQ2", "NAQ"];
const cols = ["#_mean", "#_median", "#_std", "#_cov"];

const nDummyRows = 15;
const nDummyCols = 6;
const dummyMatrix = Array.from({ length: nDummyRows }).map((_) =>
  Array.from({ length: nDummyCols }).map((_) => 0.6 * Math.random())
);
const dummyRows = Array.from({ length: nDummyRows }).map(
  (_, i) => `Row${i + 1}`
);
const dummyCols = Array.from({ length: nDummyCols }).map(
  (_, i) => `Col${i + 1}`
);

const HeatTables = () => {
  const [winWidth, setWinWidth] = useState(window.innerWidth);
  // const [dailyEntriesPP, setDailyEntriesPP] = useState([]);
  // const [daysAvgK, setDaysAvgK] = useState(3);
  // const [daysMax, setDaysMax] = useState(150);
  const [featureGroups, setFeatureGroups] = useState([
    "All",
    "MFCC",
    "Spectral",
    "Glottal",
    "Period",
    "Jitter",
    "Shimmer",
    "Amplitude",
    "Formant",
    "Forced align",
    "VAD",
  ]);
  const [funcIds, setFuncIds] = useState([
    { key: "p_mwu", text: "p-value (Mann-Whitney U)" },
  ]);
  const [featureNames, setFeatureNames] = useState([]);
  // const [patientIds, setPatientIds] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("All");
  const [selectedFunc, setSelectedFunc] = useState({
    key: "x_mean",
    text: "Mean",
  });

  const [featureInfo, setFeatureInfo] = useState(null);
  // const [totalPatients, setTotalPatients] = useState(0);

  // const [currentPage, setCurrentPage] = useState(1);
  // const patientsPerPage = 15;

  // const ENDPOINT = "http://127.0.0.1:8000";

  const [featureTables, setFeatureTables] = useState([
    {
      title: "test",
      data: dummyMatrix,
      rowNames: dummyRows,
      colNames: dummyCols,
    },
  ]);

  const fetchFeatureTables = async () => {
    try {
      const response = await fetch(`${ENDPOINT}/feature-tables`);
      if (!response.ok) {
        throw new Error(`Error fetching feature info: ${response.statusText}`);
      }
      const jsonData = await response.json();
      setFeatureTables(jsonData.data);
      console.log(jsonData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      await fetchFeatureTables();
    };
    fetchInitialData();
  }, []);

  const handleGroupChange = async (e) => {
    const selected = e.target.value;
    setSelectedGroup(selected);
  };

  const handleFuncChange = async (e) => {
    const value = e.target.value;
    const opt = funcIds.find((o) => String(o.text) === value);
    setSelectedFunc(opt);
  };

  useEffect(() => {
    const fetchDataForPatientAndFeature = async () => {
      fetchFeatureTables();
    };

    fetchDataForPatientAndFeature();

    // fetchFeatureInfo(selectedFeature);
  }, [selectedGroup, selectedFunc]);

  return (
    <Grid
      templateColumns={{ base: "1fr", md: "3fr 1fr" }}
      gap={3}
      p={4}
      mt={20}
    >
      {/* Controls (Total Patients, Patient ID, Features, Legend, and Pagination) */}
      <GridItem order={{ base: 1, md: 2 }}>
        <Box mb={8}>
          <HStack spacing="1" align="center" mb={6}>
            <Heading as="h5" size="m" mb={0}>
              Select feature group
            </Heading>
            <MaterialSymbol
              // as={MaterialSymbol}
              icon="list_alt"
              size={22}
              // fontSize="1.25em" // scales with text size
              verticalAlign="text-bottom"
              fill={0}
              grade={0}
              weight={300}
              aria-hidden // decorative
            />
          </HStack>

          <Select value={selectedGroup} onChange={handleGroupChange}>
            {featureGroups.map((id) => (
              <option key={id} value={id}>
                {id}
              </option>
            ))}
          </Select>
        </Box>

        {/* Feature selection, Mean Days, Max Days Sliders */}
        <Box p={4} boxShadow="md" borderRadius="md" mb={8}>
          <VStack align="stretch" spacing={4}>
            <Box>
              <HStack spacing="1" align="center" mb={2}>
                <Text m={0}>Metric</Text>
                <MaterialSymbol
                  // as={MaterialSymbol}
                  icon="function"
                  size={22}
                  // fontSize="1.25em" // scales with text size
                  verticalAlign="text-bottom"
                  fill={1}
                  grade={0}
                  weight={300}
                  aria-hidden // decorative
                />
              </HStack>
              <Select value={selectedFunc.text} onChange={handleFuncChange}>
                {funcIds.map((d) => (
                  <option key={d.key} value={d.text}>
                    {d.text}
                  </option>
                ))}
              </Select>
            </Box>

          </VStack>
        </Box>

   
      </GridItem>

      {/* Scatter Plot */}
      <GridItem order={{ base: 2, md: 1 }}>
        <Box w="100%" p={4}>
          <Heading as="h2" size="md" mb={8} textAlign={"center"}>
            {/* Total Patients: {totalPatients} */}
          </Heading>

          {featureTables?.map((d, i) => (
            <Box key={d.title}>              
              <Heading as="h2" size="md" my={3}>{d.title}</Heading>
              <HeatTable
                className={d.title}
                tableType="p"
                values={d.data}
                rowLabels={d.rowNames}
                colLabels={d.colNames}
              />
            </Box>
          ))}

        </Box>
      </GridItem>
    </Grid>
  );
};

export default HeatTables;
